// extracted by mini-css-extract-plugin
export var dropdown = "_v1-0";
export var imageWrapper = "_v1-3";
export var itemNameContainer = "_v1-1";
export var productImage = "_v1-2";
export var spinnerWrapper = "_v1-4";